import { setWebpackPublicPath } from '@markit/web-component-bootstrap';

// NOTE: This is not yet working. Problem is in the Webpack configuration not using this value.
setWebpackPublicPath();
